import { gql } from "@apollo/client";

export const GET_FUNCIONES = gql`
    query GetFuncionesProfesional {
        funcionesProfesional{
            idFuncion
            descripcion
        }
    }
`;

export const adaptFuncionesArray = (funciones) => {
  return funciones?.map((funcion) => ({
    id: funcion.idFuncion,
    displayName: funcion.descripcion
  }));
};